
const refundData = [
  {
    method: 'Credit / Debit Card',
    time: '3–5 Business Days',
    note: 'Refund appears on your next billing statement',
  },
  {
    method: 'PayPal',
    time: '1–3 Business Days',
    note: 'Refund credited directly to your PayPal balance',
  },
  {
    method: 'Store Credit',
    time: 'Instant',
    note: 'Receive 110% of your purchase value as store credit',
  },
  {
    method: 'Gift Card',
    time: '1 Business Day',
    note: 'New gift card issued for the original amount',
  },
];

const nonReturnableItems = [
  'Opened or used perfume bottles',
  'Personalized or engraved products',
  'Gift cards and promotional items',
  'Products purchased during final sale events',
];

export default function RefundTable() {
  return (
    <section id="refunds" className="py-20 bg-white">
      <div className="max-w-7xl mx-auto px-6">
        <div className="text-center mb-14">
          <p className="text-[#2E7D32] text-sm tracking-[0.2em] mb-3 font-medium">TRANSPARENT PROCESS</p>
          <h2 className="text-3xl font-serif text-gray-900 mb-4">Refund Information</h2>
          <p className="text-gray-500 text-sm max-w-lg mx-auto leading-relaxed">
            We process refunds promptly once your return is received and inspected. Here\u2019s what to expect based on your payment method.
          </p>
        </div>

        <div className="bg-[#F1F8E9] rounded-2xl overflow-hidden mb-12">
          <table className="w-full">
            <thead>
              <tr className="bg-[#2E7D32]">
                <th className="text-left px-8 py-4 text-white text-sm font-medium tracking-wide">Payment Method</th>
                <th className="text-left px-8 py-4 text-white text-sm font-medium tracking-wide">Processing Time</th>
                <th className="text-left px-8 py-4 text-white text-sm font-medium tracking-wide">Notes</th>
              </tr>
            </thead>
            <tbody>
              {refundData.map((row, index) => (
                <tr key={row.method} className={index % 2 === 0 ? 'bg-white' : 'bg-[#F1F8E9]/50'}>
                  <td className="px-8 py-5">
                    <span className="text-sm font-medium text-gray-900">{row.method}</span>
                  </td>
                  <td className="px-8 py-5">
                    <span className="inline-flex items-center gap-1.5 text-sm text-[#2E7D32] font-medium">
                      <i className="ri-time-line text-base"></i>
                      {row.time}
                    </span>
                  </td>
                  <td className="px-8 py-5">
                    <span className="text-sm text-gray-500">{row.note}</span>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>

        <div className="grid grid-cols-2 gap-8">
          <div className="bg-[#FFF8E1] rounded-xl p-8 border border-[#FFE082]/50">
            <div className="flex items-center gap-3 mb-5">
              <div className="w-10 h-10 rounded-lg bg-[#FFF3C4] flex items-center justify-center">
                <i className="ri-error-warning-line text-lg text-[#F9A825]"></i>
              </div>
              <h3 className="text-sm font-semibold text-gray-900">Non-Returnable Items</h3>
            </div>
            <ul className="space-y-3">
              {nonReturnableItems.map((item) => (
                <li key={item} className="flex items-start gap-2.5 text-sm text-gray-600">
                  <i className="ri-close-circle-line text-[#F9A825] text-base mt-0.5 flex-shrink-0"></i>
                  {item}
                </li>
              ))}
            </ul>
          </div>

          <div className="bg-[#E8F5E9] rounded-xl p-8 border border-[#A5D6A7]/50">
            <div className="flex items-center gap-3 mb-5">
              <div className="w-10 h-10 rounded-lg bg-[#C8E6C9] flex items-center justify-center">
                <i className="ri-exchange-funds-line text-lg text-[#2E7D32]"></i>
              </div>
              <h3 className="text-sm font-semibold text-gray-900">Exchange Policy</h3>
            </div>
            <ul className="space-y-3">
              <li className="flex items-start gap-2.5 text-sm text-gray-600">
                <i className="ri-checkbox-circle-line text-[#2E7D32] text-base mt-0.5 flex-shrink-0"></i>
                Free exchanges on all eligible items within 30 days
              </li>
              <li className="flex items-start gap-2.5 text-sm text-gray-600">
                <i className="ri-checkbox-circle-line text-[#2E7D32] text-base mt-0.5 flex-shrink-0"></i>
                Exchange for a different size, scent, or product of equal value
              </li>
              <li className="flex items-start gap-2.5 text-sm text-gray-600">
                <i className="ri-checkbox-circle-line text-[#2E7D32] text-base mt-0.5 flex-shrink-0"></i>
                Price difference refunded or charged for unequal exchanges
              </li>
              <li className="flex items-start gap-2.5 text-sm text-gray-600">
                <i className="ri-checkbox-circle-line text-[#2E7D32] text-base mt-0.5 flex-shrink-0"></i>
                Expedited shipping available on all exchange orders
              </li>
            </ul>
          </div>
        </div>
      </div>
    </section>
  );
}
